import "./about.css";

export default function About() {
	return (
		<div className="about container">
			<h1>About Page</h1>
		</div>
	);
}
